import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import record from '@/components/record'
import homeworkErrorBook from '@/components/homeworkErrorBook'
import examinationReport from '@/components/examinationReport'
import cuoti_print from '@/components/cuoti_print'

Vue.use(Router)

const router= new Router({
  mode: 'history',
  base: "/qjyxWeb-user",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      redirect: '/record',
      meta: { requiresAuth: true }, // 设置路由元信息，表示需要登录才能访问
      children: [
        {
          path: '/record',
          component: record
        },
        {
          path: '/homeworkErrorBook',
          component: homeworkErrorBook
        },
        {
          path: '/examinationReport',
          component: examinationReport,
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: { requiresAuth: false }
    },
    {
      path: '/cuoti_print',
      name: 'cuoti_print',
      component: cuoti_print,
      meta: { requiresAuth: false }
    }
    
  ]
})

// router.beforeEach((to, from, next) => {
//   console.log('888888888888',to.matched.some(record => record.meta.requiresAuth));
//   if (to.matched.some(record => record.meta.requiresAuth)) { // 判断该路由是否需要登录才能访问
//     let gg='999999999';
//     console.log('966966',gg==='999999999');
//     if (gg==='999999999') { // 判断用户是否已经登录
//       console.log('9999');
//       next({
//         path: '/login',
//         // query: { redirect: to.fullPath } // 记录当前路由，以便登录后自动跳转
//       })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js